import { useCopyIsinTracking } from "src/hooks/use-copy-isin-tracking";
import { IGlobal } from "src/types/layout";
import { useGtm } from "./use-gtm";

interface IUseInitializeTrackingProps<TData> {
    global: IGlobal | null;
    data: TData | null | undefined;
}

export function useInitializeTracking<TData>({ global, data }: IUseInitializeTrackingProps<TData>) {
    useGtm<TData>({ global, data });
    useCopyIsinTracking();
}
